var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.5C8.44375 17.5 9.625 16.52 9.625 15.3125H4.375C4.375 16.52 5.55625 17.5 7 17.5ZM12.355 11.5325V7C12.355 4.48875 10.5875 2.345 8.23375 1.81125V1.23375C8.23375 0.53375 7.7 0 7 0C6.3 0 5.76625 0.53375 5.76625 1.23375V1.81125C3.42125 2.345 1.645 4.48875 1.645 7V11.5325L0 13.1775V14H14V13.1775L12.355 11.5325Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.93a5778ce97151c64e39651f26798e32.svg";
export { ForwardRef as ReactComponent };